const accordionItems = document.querySelectorAll('.accordion .accordion-title');

function getAccordionItems() {
    // Select all menu items that have a dropdown menu

    // Add event listeners for click and keyboard
    Array.prototype.forEach.call(accordionItems, function(el){
        el.addEventListener('click', openAccordionItem);
        //el.querySelector('a').addEventListener('keyup', dropdownKeyupHandler);
        //el.querySelector('a').addEventListener('keydown', dropdownKeydownHandler);
    });
}
getAccordionItems();

// Open dropdown menuu
function openAccordionItem() {
    if (this.parentNode.classList.contains("open-accordion")) {
        event.preventDefault();
        this.parentNode.classList.remove("open-accordion");
        this.setAttribute('aria-expanded', "false"); // Indicates to screen readers that a collapsible area is closed
    } else {
        event.preventDefault();
        Array.prototype.forEach.call(accordionItems, function(el){ 
            el.classList.remove("open-accordion"); // Closes any open menus
        });
        this.parentNode.classList.add("open-accordion");
        this.setAttribute('aria-expanded', "true"); // Indicates to screen readers users that a collapsible area is opened
    }
}

export { getAccordionItems };